import { getAccessToken, onTokenChange } from './gisClient';

/**
 * Keeps gapi.client's Authorization header in step with the GIS token.
 *
 * This used to own a setTimeout chain that refreshed gapi.auth2's session and
 * pushed the result to the service worker. Both jobs moved: renewal scheduling
 * belongs to gisClient, which owns the token, and the worker is fed from the
 * same place. What is left is the one thing gapi itself needs - it does not
 * know about GIS, so somebody has to hand it the token.
 */
export default class GapiTokenService {

  private unsubscribe?: () => void;

  start() {
    if (this.unsubscribe) {
      return;
    }

    this.unsubscribe = onTokenChange(token => {
      if (typeof gapi === 'undefined' || !gapi.client) {
        return;
      }

      // Passing null clears it, so an expired or revoked token stops being
      // sent rather than producing confusing 401s.
      gapi.client.setToken(token ? { access_token: token.accessToken } : null as any);
    });

    // Catch up with a token acquired before we subscribed.
    const existing = getAccessToken();
    if (existing && typeof gapi !== 'undefined' && gapi.client) {
      gapi.client.setToken({ access_token: existing });
    }
  }

  stop() {
    this.unsubscribe?.();
    this.unsubscribe = undefined;
  }
}
